import { gql } from "@apollo/client";

export const GET_CLASSES = gql`
  query getStudents($reader_type: String) {
    classes {
      value: id
      txt: name
      teacher_id
      students
      created
    }
    books(reader_type: $reader_type) {
      id
      title
      is_author
      language {
        name
      }
    }
  }
`;

export const GET_GRADES = gql`
  query getGrades($class_id: ID!, $book_id: ID, $is_creator: Boolean) {
    grades(
      class_id: $class_id
      all: true
      book_id: $book_id
      is_creator: $is_creator
    ) {
      student {
        id
        created
        name
        login_code
        class_id
        minutes
        semester_minutes
        last_login
        class {
          name
        }
        history {
          score
          allow_retake
          request_retake
        }
      }
      book {
        title
        url
        id
        chapters
        chapter_questions
        has_introduction
        is_author
      }
      grades {
        chapter
        grade
        tries
        past
        question_num
        disabled
        requested_retake
      }
      retakes_count
      overall {
        grade
        question_num
      }
    }
  }
`;
